import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppGlobals } from '@app/app.global';

@Injectable({
  providedIn: 'root'
})
export class PushToRetailPosService {

  constructor(
    private http: HttpClient,
    private appGlobals: AppGlobals
  ) { }

  getCompanyDetails(company = null) {
    if (company) {
      return this.http.get(`${this.appGlobals.apiUrl.metadata}company/details?company=${company}`);
    } else {
      return this.http.get(`${this.appGlobals.apiUrl.metadata}company/details`);
    }
  }

  getCompanyList(queryParams) {
    if (queryParams) {
      return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}company/list`, { params: queryParams })
    } else {
      return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}company/list`)
    }
  }

  getPurchaseInvoiceList(body) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.invoice}invoice-list-for-retail-pos`, body);
  }

  pushInvoicesToRetailPos(body) {
    return this.http.post(`${this.appGlobals.apiUrl.invoice}push-to-retail-pos`, body);
  }

  invoicePendingTags(params) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}invoice-pending-tags`, { params: params });
  }
}
